/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import React, { useContext, useEffect, useRef, useState } from "react";
import sass from "./levels.module.sass";
import { ReactComponent as ActionMenuIcon } from "images/ActionMenuIcon.svg";
import PortalWrapper from "components-new/PortalWrapper";
import { Button } from "components/shared";
import { BUTTON_VARIANTS } from "components/shared/Button/Button";
import { CreateContext } from "pages/StepPages/StepFour/One/Tables/Tables";
import LevelsOfVariablesModule from "pages/StepPages/StepFour/One/Tables/TableNavigate/LevelsOfVariantsTable/LevelsOfVariablesModule";
import { useOutsideAlerter } from "hooks/useOutsideAlerter";
import DropMenu from "pages/StepPages/StepFour/One/Tables/TableNavigate/DropMenu";
import { fetchLevelsOfVariablesTableData } from "pages/StepPages/StepFour/One/Tables/fetch";
import { useParams } from "react-router-dom";
import { ReactComponent as LoadingIcon } from "images/load.svg";
import parentSass from "pages/StepPages/StepFour/One/Tables/TableNavigate/nav.module.sass";
import { snackWrapper } from "helpers";
import { ChangeActiveTabContext } from "../TableNavigate";
import { ThreatImplementationLevelResponse } from "libs/apiClient/data-contracts";
import { organizationAPI } from "libs/apiClient/Organization";

interface IModal {
	data: null | (Omit<ThreatImplementationLevelResponse, "violatorType"> & { type: string });
	active: "create" | "edit" | null;
}

const LevesOfVariables = () => {
	const { container, openConfirm, confirm, currentThread, selectFile, checkTables } = useContext(CreateContext);
	const { updateTabs } = useContext(ChangeActiveTabContext);
	const [modal, setModal] = useState<IModal>({ data: null, active: null });
	const [data, setData] = useState<ThreatImplementationLevelResponse[]>([]);
	const [load, setLoad] = useState(false);

	const params = useParams();

	useEffect(() => {
		setLoad(true);
		fetchLevelsOfVariablesTableData(Number(params.threadId))
			.then((levelOfVariables) => {
				setData(levelOfVariables);
				setLoad(false);
			})
			.catch(() => setLoad(false));
		//eslint-disable-next-line
	}, []);

	const [target, setTarget] = useState<HTMLOrSVGElement | undefined>();
	const toggleTarget = (e: React.MouseEvent<HTMLOrSVGElement>) => {
		e.stopPropagation();
		target ? setTarget(undefined) : setTarget(e.currentTarget);
	};

	const removeItem = () => {
		if (confirm) {
			openConfirm();
			return;
		}
		if (target) {
			organizationAPI.objectLevelDelete(+target.dataset.id!).then(() => {
				snackWrapper("success", "Запись успешно удалена");
				setData([...data].filter((_) => _.id !== Number(target.dataset.id)));
				updateTabs("LEVEL");
				setTarget(undefined);
			});
		}
	};

	useOutsideAlerter(target, () => setTarget(undefined));
	const ref = useRef<HTMLInputElement>(null);

	return (
		<div className={sass.table}>
			<DropMenu target={target} click={removeItem} />

			<LevelsOfVariablesModule
				data={data}
				toggle={modal.active}
				active={modal.data}
				close={() => setModal({ data: null, active: null })}
				replace={(datas) => setData(datas)}
			/>
			{container.current && (
				<PortalWrapper containerRef={container.current}>
					<input
						ref={ref}
						accept={".docx, application/pdf"}
						onChange={(e) => {
							selectFile(e);
						}}
						id={"file"}
						type={"file"}
						disabled={currentThread?.threatStatus === "APPROVED"}
						hidden={true}
					/>
					<Button
						onClick={() => {
							checkTables({
								type: "model",
								ok: () => {
									ref.current?.click();
								},
							});
						}}
						disabled={currentThread?.threatStatus === "APPROVED"}
						variant={BUTTON_VARIANTS.OUTLINED}>
						Загрузить утвержденный документ
					</Button>
					<Button
						variant={BUTTON_VARIANTS.CONTAINED}
						onClick={() => {
							confirm ? openConfirm() : setModal({ data: null, active: "create" });
						}}>
						Добавить информацию
					</Button>
				</PortalWrapper>
			)}
			<div className={sass.sticky}>
				<div className={sass.caption}>
					Таблица 5 – Уровни возможностей нарушителей по реализации угроз безопасности
					<br />
					информации
				</div>
				<table>
					<thead>
						<tr>
							<th>Уровень возможностей нарушителей</th>
							<th>Возможности нарушителей по реализации угроз безопасности информации</th>
							<th>Виды нарушителей</th>
							<th />
						</tr>
					</thead>
				</table>
			</div>
			<div data-comment-false={true} className={sass.scroll_wrapper}>
				{load ? (
					<LoadingIcon width={50} height={50} className={parentSass.loading} />
				) : (
					<div className={sass.scroll}>
						<table>
							<tbody>
								{data.map((_, index) => {
									return (
										<tr
											key={index}
											onClick={() => {
												if (confirm) {
													openConfirm();
												} else {
													const { violatorType, ...rest } = _;
													setModal({ data: { ...rest, type: violatorType || "" }, active: "edit" });
												}
											}}>
											<td>
												{_.level} ({_.name})
											</td>
											<td>{_.possibility}</td>
											<td>{_.violatorType}</td>
											<td>
												<ActionMenuIcon data-id={_.id} onClick={toggleTarget} />
											</td>
										</tr>
									);
								})}
							</tbody>
						</table>
					</div>
				)}
			</div>
		</div>
	);
};

export default LevesOfVariables;
